import { Text, View } from '@react-pdf/renderer';

import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { styles } from '../../styles';
import { stylesAwesome } from '@composites/PDF/AgendaPdfContent/components/EventAtGlance';
import { useTranslation } from 'react-i18next';

interface ServiceThatConvinceProps {
  event: PublicEventDetailsResponse;
}

const ServiceThatConvince = ({ event }: ServiceThatConvinceProps) => {
  const { t } = useTranslation();

  const serviceThatConvinceItems = [
    {
      title: 'service-that-convince-title-1',
      subtitle: 'service-that-convince-subtitle-1',
    },
    {
      title: 'service-that-convince-title-2',
      subtitle: 'service-that-convince-subtitle-2',
    },
    {
      title: 'service-that-convince-title-3',
      subtitle: 'service-that-convince-subtitle-3',
    },
  ];
  return (
    <View>
      <View
        style={{
          ...styles.rightSideBody,
          gap: 20,
          alignItems: 'flex-start',
        }}
      >
        <Text style={{ ...styles.bodyTitle, fontSize: 42 }}>
          {t('prospectus-title-11')}
        </Text>
        <Text style={{ ...styles.bodyTitle, fontSize: 42 }}>
          {t('prospectus-title-12')}
        </Text>
        <View style={styles.bodyLineBar} />
        <Text style={styles.serviceTitle}>{t('prospectus-title-10')}</Text>
      </View>
      <View style={styles.IconBarWrapper}>
        <Text style={stylesAwesome.whiteIcon}>{'\uf6ff'}</Text>
        <View style={styles.serviceLineBar} />
        <Text style={stylesAwesome.whiteIcon}>{'\uf6ff'}</Text>
        <View style={styles.serviceLineBar} />
        <Text style={stylesAwesome.whiteIcon}>{'\uf6ff'}</Text>
        <View style={styles.serviceLineBar} />
        <View style={styles.arrow}></View>
      </View>

      <View style={styles.serviceThatConvinceWrapper}>
        {serviceThatConvinceItems?.map(item => (
          <View style={styles.keyTopicsColumn} key={item.title}>
            <View style={styles.increaseSalesItem}>
              <Text style={styles.serviceThatConvinceTitle}>
                {t(item.title)}
              </Text>
              <Text style={styles.increaseSalesBody}>{t(item.subtitle)}</Text>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

export default ServiceThatConvince;
